module.exports = "<div class=\"\">\n <router-outlet></router-outlet>\n</div>"